/* LOVE ADORNED: search results load the next page as you scroll.
   Replaces ajaxinate.js that was loaded (blocking) from another store's server. */
(function () {
  function Ajaxinate(config) {
    this.s = Object.assign({ pagination: '.AjaxinatePagination', container: '.AjaxinateLoop', loadingText: 'Loading' }, config || {});
    this.c = document.querySelector(this.s.container); this.p = document.querySelector(this.s.pagination);
    this.check = this.check.bind(this);
    if (this.c && this.p) { document.addEventListener('scroll', this.check, { passive: true }); window.addEventListener('resize', this.check); this.check(); }
  }
  Ajaxinate.prototype.stop = function () { document.removeEventListener('scroll', this.check); window.removeEventListener('resize', this.check); };
  Ajaxinate.prototype.check = function () {
    if (this.busy || !this.p) return;
    var r = this.p.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight;
    if (r.top > h + 1000) return;
    var a = this.p.querySelector('a'); if (!a || !a.href) { this.stop(); return; }
    var self = this; this.busy = true;
    fetch(a.href).then(function (res) { return res.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var nc = d.querySelector(self.s.container), np = d.querySelector(self.s.pagination);
      if (nc) self.c.insertAdjacentHTML('beforeend', nc.innerHTML);
      self.p.innerHTML = np ? np.innerHTML : '';
      self.busy = false; self.check();
    }).catch(function () { self.busy = false; });
  };
  window.Ajaxinate = window.Ajaxinate || Ajaxinate;
})();
